import React, { useState , useEffect} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import ReactEcharts from "echarts-for-react"
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import StringUtil from "utils/StringUtil";
import AuthMenuLink from "components/link";
import menuStore from "common/menu/store/MenuStore";

function ContentsContainer() {

	let today:string = DateUtil.currentDateFormat("YYYY-MM-DD");
    let year:string = DateUtil.currentDateFormat("YYYY");
	
	
    //출연기업 현황 수
	const [corpACnt,setCorpACnt] = useState(0);  //대기업 
	const [corpBCnt,setCorpBCnt] = useState(0);  //공공기업
	const [corpCCnt,setCorpCCnt] = useState(0);  //중견기업
	const [corpDCnt,setCorpDCnt] = useState(0);  //중소기업
	const [corpECnt,setCorpECnt] = useState(0);  //기타
	const [corpTotalCnt,setCorpTotalCnt] = useState(0);  //합계

	//결재함 건수
	//10 결재중 , 15 전결 32 반려 20 집행요청 51 집행처리중 52 집행완료 
	const [appr10Cnt,setAppr10Cnt] = useState(0);  //결재중
	const [appr15Cnt,setAppr15Cnt] = useState(0);  //전결
	const [appr32Cnt,setAppr32Cnt] = useState(0);  //반려
	const [appr20Cnt,setAppr20Cnt] = useState(0);  //집행요청
	const [appr51Cnt,setAppr51Cnt] = useState(0);  //집행처리중
	const [appr52Cnt,setAppr52Cnt] = useState(0);  //집행완료

	//출연금 현황
	const [SUM_IN_AMT, setSUM_IN_AMT] = useState('');
	const [SUM_OUT_AMT, setSUM_OUT_AMT] = useState('');
	const [SUM_REFUND_AMT, setSUM_REFUND_AMT] = useState('');
	const [TOTAL_SUM, setTOTAL_SUM] = useState('');
	const [SUM_SUPP_CORP, setSUM_SUPP_CORP] = useState('');
   
    //사업별 출현현황
	const [bizNmByDon, setBizNmByDon] = useState('');
	const [bizNmByDonListNm, setBizNmByDonListNm] = React.useState<any[]>([]);  
	const [bizNmByDonListAmt, setBizNmByDonListAmt] = React.useState<any[]>([]);  

	const [options, setOptions] = useState({});
	let totalCoprCnt:number = 0;
	
	function dateLpad(num){
		if(num+''.length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	// 상세 데이터 가져오기
	async function initCall(){
		const response:any = await CommonUtil.execute({
			url:'mainpage_dashboard',
			data: {},
			progressBar:true
		})

		const lastStatusList = response.LAST_STATUS_LIST;
		const corpCountList = response.CORP_COUNT_LIST;
		const donList = response.DON_LIST[0];
		const bizNmByDonList = response.BIZNM_DON_LIST;

		//기업카운트 
		corpCountList?.forEach((item, index) => {
			if(item.CORP_SIZE_CD == 'A'){
				setCorpACnt(item.CORP_SIZE_CNT);
			}else if(item.CORP_SIZE_CD == 'B'){
				setCorpBCnt(item.CORP_SIZE_CNT);
			}else if(item.CORP_SIZE_CD == 'C'){
				setCorpCCnt(item.CORP_SIZE_CNT);
			}else if(item.CORP_SIZE_CD == 'D'){
				setCorpDCnt(item.CORP_SIZE_CNT);
			}else if(item.CORP_SIZE_CD == 'E'){
				setCorpECnt(item.CORP_SIZE_CNT);
			}
			
		});
		
		setCorpTotalCnt(corpCountList[0].CORP_TOTAL_CNT);
		

		//10 결재중 , 15 전결 32 반려 20 집행요청 51 집행처리중 52 집행완료 
		lastStatusList?.forEach((item, index) => {
			if(item.LAST_STATUS == '10'){  //10 결재중
				setAppr10Cnt(item.LAST_STATUS_CNT);
			}else if(item.LAST_STATUS == '15'){  //15 전결
				setAppr15Cnt(item.LAST_STATUS_CNT);
			}else if(item.LAST_STATUS == '32'){  //32 반려
				setAppr32Cnt(item.LAST_STATUS_CNT);
			}else if(item.LAST_STATUS == '20'){   // 20 집행요청
				setAppr20Cnt(item.LAST_STATUS_CNT);
			}else if(item.LAST_STATUS == '51'){  //51 집행처리중
				setAppr51Cnt(item.LAST_STATUS_CNT);
			}else if(item.LAST_STATUS == '52'){  //52 집행완료 
				setAppr52Cnt(item.LAST_STATUS_CNT);
			}
			
		});
		
		//출연금 현황
		setSUM_IN_AMT(donList.SUM_IN_AMT);
		setSUM_OUT_AMT(donList.SUM_OUT_AMT);
		setSUM_REFUND_AMT(donList.SUM_REFUND_AMT);
		setTOTAL_SUM(donList.TOTAL_SUM);	
		setSUM_SUPP_CORP(donList.SUM_SUPP_CORP_CNT);
		

		//사업별 출현현황
		bizNmByDonList?.forEach((item, index) => {
			bizNmByDonListNm.push(item.BIZ_SHORT_NM);
			bizNmByDonListAmt.push(Number(item.DON_AMT));
		});


		//차트옵션
		setOptions({
			title: {
			text: ''
			},
			tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
			},
			legend: {},
			grid: {
			left: '3%',
			right: '4%',
			bottom: '3%',
			containLabel: true
			},
			xAxis: {
			type: 'value'
			},
			yAxis: {
			type: 'category',
			data: bizNmByDonListNm
			},
			series: [
			{
			name: '',
			type: 'bar',
			data: bizNmByDonListAmt
			}
			]
		})

	};
	
	 // init 
	React.useEffect(() => {
		menuStore.removeCurrentMenu();
		initCall();
		
	},[]) 

		

	return (
		<PageContainer>
			
			<div className="adm-dash">
				{/* 1.상생협력기금 현황 */}
				<div className="col col-5 mr10">
					<div className="adm-dash-section adm-dash-section-01">
						<div className="tit-date">
							<h2 className="tit">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;대중소기업상생협력기금 현황(2024.8월 말 시스템 개편 이후)</h2>
							<p className="date">{dateToStr(today)} 기준</p> 
						</div>
						<ul className="main-list">
							<li>
								<AuthMenuLink menuId={"SEJYU222163ADA8B40"}>
									<p className="tit-d2">출연금 현황</p>
									<p className="value"><em>{SUM_IN_AMT}</em> 원</p>
								</AuthMenuLink>
							</li>
							<li>
								<AuthMenuLink menuId={"SEJYU222163ADA8B40"}>
									<p className="tit-d2">출연잔액</p>
									<p className="value"><em>{TOTAL_SUM}</em> 원</p>
								</AuthMenuLink>
							</li>
							<li>
								<AuthMenuLink menuId={"SEJYU222163ADA8B40"}>
									<p className="tit-d2">지원금 현황</p>
									<p className="value"><em>{SUM_OUT_AMT}</em> 원</p>
								</AuthMenuLink>
							</li>
							<li>
								<AuthMenuLink menuId={"SEJYU222163ADA8B40"}>
									<p className="tit-d2">지원기업수</p>
									<p className="value"><em>{SUM_SUPP_CORP}</em> 개사</p>
								</AuthMenuLink>
							</li>
						</ul>
					</div>
				</div>

				<div className="pt">
					<div className="row">
						<div className="col col-5 mr10">
							{/* 2.출연기업 현황 */}
							<div className="adm-dash-section adm-dash-section-02">
								<div className="tit-date">
									<h2 className="tit">기업유형별 WINFIS 가입현황</h2>
									<p className="date">{dateToStr(today)} 기준</p> 
								</div>
								<ul className="main-list">
									<li>
										<p className="tit-d2">대기업</p>
										<p className="value"><em>{corpACnt}</em> 개사</p>
									</li>
									<li>
										<p className="tit-d2">중견기업</p>
										<p className="value"><em>{corpCCnt}</em> 개사</p>
									</li>
									<li>
										<p className="tit-d2">중소기업</p>
										<p className="value"><em>{corpDCnt}</em> 개사</p>
									</li>
									<li>
										<p className="tit-d2">공공기관</p>
										<p className="value"><em>{corpBCnt}</em> 개사</p>
									</li>
									<li>
										<p className="tit-d2">기타</p>
										<p className="value"><em>{corpECnt}</em> 개사</p>
									</li>
									<li className="tot">
										<p className="tit-d2">총</p>
										<p className="value"><em>{corpTotalCnt}</em> 개사</p>
									</li>
								</ul>
							</div>

							{/* 3.결재함 */}
							<div className="adm-dash-section adm-dash-section-03">
								<div className="tit-date">
									<h2 className="tit">내 결재함</h2>
									<p className="date">{year}년</p> 
								</div>
								<ul className="main-list">
									<li>
										<Link to="/admin/adm_7000/adm7100" >
											<p className="tit-d2">집행완료</p>
											<p className="value"><em>{appr52Cnt}</em> 건</p>
										</Link>
									</li>
									<li>
										<Link to="/admin/adm_7000/adm7100" >
											<p className="tit-d2">결재중</p>
											<p className="value"><em>{appr10Cnt}</em> 건</p>
										</Link>
									</li>
									<li>
										<Link to="/admin/adm_7000/adm7100" >
											<p className="tit-d2">전결</p>
											<p className="value"><em>{appr15Cnt}</em> 건</p>
										</Link>
									</li>
								</ul>
							</div>						
						</div>
						<div className="col col-5 ml10">
							{/* 4.사업별 출연현황 */}
							<div className="adm-dash-section adm-dash-section-04">
								<div className="tit-date">
									<h2 className="tit">사업별 출연현황</h2>
									<p className="date">{dateToStr(today)} 기준 (단위:백만원)</p> 
								</div>
								<div>

								<ReactEcharts
									option={options}
									style={{ width: "100%", height: "565px" }}
									
								/>
								</div>
							</div>
						</div>
					</div>
				</div>				
			</div>

		</PageContainer>
	);
}
export default ContentsContainer;


